const testimonials = [
  {
    name: 'Alessandro B.',
    location: 'Milano, Italia',
    rating: 5,
    title: 'Finalmente una guida chiara!',
    text: 'Ho scoperto Itaobuy Spreadsheet grazie a questo sito e ho risparmiato oltre il 40% sui miei acquisti. Le guide sono scritte in un italiano perfetto e le categorie sono facilissime da navigare.',
  },
  {
    name: 'Giulia M.',
    location: 'Roma, Italia',
    rating: 5,
    title: 'Strumento indispensabile',
    text: 'Uso Itaobuy Spreadsheet da mesi e non potrei più farne a meno. Il confronto prezzi è accurato e le recensioni mi hanno aiutata a evitare brutte sorprese. Consigliatissimo!',
  },
  {
    name: 'Francesco R.',
    location: 'Napoli, Italia',
    rating: 5,
    title: 'Risparmio garantito',
    text: 'Avevo sempre paura di fare acquisti online sbagliati. Con Itaobuy Spreadsheet ho trovato prodotti di qualità a prezzi onesti. La guida per principianti è stata fondamentale.',
  },
  {
    name: 'Sofia L.',
    location: 'Torino, Italia',
    rating: 4,
    title: 'Ottimo per lo shopping',
    text: 'Il database è vastissimo e sempre aggiornato. Apprezzo molto la sezione sicurezza con i consigli prima dell\'acquisto. Un piccolo gioiello per chi ama lo shopping intelligente.',
  },
  {
    name: 'Matteo D.',
    location: 'Firenze, Italia',
    rating: 5,
    title: 'Community eccellente',
    text: 'Oltre alle guide, la community italiana è molto attiva e disponibile. Ho imparato strategie che non avrei mai scoperto da solo. Itaobuy Spreadsheet è il futuro dello shopping.',
  },
  {
    name: 'Chiara P.',
    location: 'Bologna, Italia',
    rating: 5,
    title: 'Semplice ed efficace',
    text: 'L\'interfaccia è intuitiva e le categorie ben organizzate. In pochi click trovo esattamente quello che cerco. Lo consiglio a tutti i miei amici appassionati di moda.',
  },
];

export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-label">Community</span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 leading-tight">
            Cosa Dicono
            <br />
            Gli Utenti
          </h2>
          <p className="text-foreground-600 text-base mt-3">Esperienze reali di shopping in Italia</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-6 ${idx === testimonials.length - 1 ? 'opacity-60' : ''}`}
            >
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{t.title}</h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-xs font-semibold text-secondary-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}